'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ActionTypes = require('pricing-pages-unified-ui/constants/ActionTypes');

var availableTrials = function availableTrials() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case _ActionTypes.AVAILABLE_TRIALS_RECEIVED:
      return payload;
    default:
      return state;
  }
};

exports.default = availableTrials;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/reducers/AvailableTrials.js
// module id = 381
// module chunks = 3 4 5